import { http, pagination } from 'utils'
import { make } from 'vuex-pathify'

export default {
  namespaced: true,

  state: {
    refunds: [],
    meta: null
  },

  actions: {
    ...make.actions('refunds'),
    ...make.actions('meta'),

    async getRefunds ({ dispatch, state }, { fresh = false, params = {} } = {}) {
      if (state.meta) {
        if (pagination(state.meta) && fresh === false) {
          return Promise.reject(new Error('No more results.'))
        }

        params.page = state.meta.current_page + 1
      }

      if (fresh) {
        params.page = 1
      }

      const response = await http.get('orders/refunds', { params })

      if (params.page === 1 || params.page === undefined) {
        dispatch('setRefunds', response.data.data)
      } else {
        dispatch('setRefunds', [...state.refunds, ...response.data.data])
      }

      dispatch('setMeta', response.data.meta)

      return response
    },

    async deleteRefundProduct ({ dispatch }, { product, refund }) {
      const response = await http.delete(`orders/refunds/${refund.id}/products/${product.id}`)

      dispatch('replaceRefundProduct', { refund, product: response.data.data })
    },

    async updateRefundProduct ({ dispatch }, { product, refund, payload }) {
      const response = await http.put(`orders/refunds/${refund.id}/products/${product.id}`, payload)

      dispatch('replaceRefundProduct', { refund, product: response.data.data })
    },

    replaceRefundProduct ({ state, dispatch }, { refund, product }) {
      const refundIndex = state.refunds.findIndex(({ id }) => id === refund.id)
      const productIndex = refund.products.findIndex(({ id }) => id === product.id)

      const newRefund = { ...refund }
      newRefund.products.splice(productIndex, 1, product)

      const newRefunds = [...state.refunds]
      newRefunds.splice(refundIndex, 1, newRefund)

      dispatch('setRefunds', newRefunds)
    },

    resetRefunds ({ dispatch }) {
      dispatch('setRefunds', [])
      dispatch('setMeta', null)
    }
  },

  mutations: {
    ...make.mutations('refunds'),
    ...make.mutations('meta')
  }
}
